module.exports = __webpack_public_path__ + "static/media/s_v10_31.16ee3747.mp3";